module.exports = __webpack_public_path__ + "static/media/note-7.0123d20b.svg";